export const NOTIFICATION_TYPE = 'user';
export const MAX_NOTIFICATION_DROPDOWN = 5;
export const INVOICES_KEYWORD = 'invoices';
export const WITHDRAW_KEYWORD = 'withdraw';
export const TOP_UP_KEYWORD = 'top-up';
export const WS_EVENT = {
    NOTIFICATION: 'user',
    BALANCE: 'balance_update',
    CLOUD_SERVER_STATUS: 'cloud_server_status_update',
    HISTORY_CREATED: 'history_created',
    CLOUD_HOSTING_RESET: 'cloud_hosting_reset',
    CARD_ADDED: 'card_added',
    DOWNLOAD_AN_INVOICE: 'download_an_invoice',
    DOWNLOAD_A_RECEIPT: 'download_a_receipt',
    DOWNLOAD_A_CREDIT_NOTE: 'download_a_credit_note',
    USER_HAS_BEEN_BANNED: 'user_has_been_banned',
    FORTUNE_WHEEL_GET_NEW_SPIN: 'fortune_wheel_get_new_spin',
    DOWNLOAD_AN_SSL_CERTIFICATE: 'download_an_ssl_certificate',
    USER_SSL_STATUS_CHANGED: 'user_ssl_status_changed',
    OMISE_WEBHOOK_RESULT: 'omise_webhook_result', // user
    PAYMENT_TRANSACTION_RESULT: 'payment_transaction_result',
};
export const NOTIFICATION_STATE = {
    READ: {
        key: 'read',
    },
    UNREAD: {
        key: 'unread',
    },
};
